export default "__VITE_ASSET__B5fnug6B__"